var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsaIcon = function SvgUsaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usa-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#949494",
    strokeWidth: 0.113,
    d: "M2.286 4.432h15.428c.687 0 1.23.485 1.23 1.069v8.996c0 .583-.543 1.068-1.23 1.068H2.286c-.687 0-1.23-.485-1.23-1.068V5.501c0-.584.543-1.069 1.23-1.069Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC1F00",
    fillRule: "evenodd",
    d: "M19 4.375H1v.75h18zm0 1.5H1v.75h18zm-18 1.5h18v.75H1zm18 1.5H1v.75h18zm-18 1.5h18v.75H1zm18 1.5H1v.75h18zm-18 1.5h18v.75H1zm18 1.5H1v.75h18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2365AB",
    d: "M7.752 4.375H1v5.252h6.752z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#usa-icon_svg__b)",
    fillRule: "evenodd",
    d: "M2.5 5.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m1.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m1.125.376a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75M7.001 5.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0M2.875 6.626a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75m1.875-.375a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m1.126.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75M7 7.001a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m-1.876.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75M4 7.001a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m-1.876.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75m1.126.375a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m1.125.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75m1.876-.375a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m.375 1.126a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75M5.5 8.502a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m-1.875.375a.375.375 0 1 0 0-.75.375.375 0 0 0 0 .75M2.5 8.502a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "usa-icon_svg__b",
    x1: 1.749,
    x2: 1.749,
    y1: 5.125,
    y2: 8.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "usa-icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 11.25,
    x: 1,
    y: 4.375,
    fill: "#fff",
    rx: 1.125
  })))));
};
export { SvgUsaIcon as ReactComponent };